export const voiceAgent = {
  header: {
    title: "KI-Sprachagent",
    subBefore: "Beantwortet Ihre Telefonanrufe mit KI in Echtzeit. Gilt für",
    subEmphasis: "Ihr gesamtes Konto",
    active: "Aktiv",
    inactive: "Inaktiv",
  },
  loading: "Konfiguration wird geladen…",
  errors: {
    load: "Die Konfiguration konnte nicht geladen werden.",
    save: "Speichern nicht möglich. Bitte versuchen Sie es erneut.",
  },
  phone: {
    title: "Telefonnummer",
    desc: "Die Nummer, die Ihre Gäste anrufen. Für Ihr Konto wird eine eigene erstellt.",
    checking: "Ihre Nummer wird geprüft…",
    pendingTitle: "Telefonie wartet auf Aktivierung",
    pendingText: "Das Erstellen von Nummern ist für Ihr Konto noch nicht freigeschaltet. Melden Sie sich bei uns und wir aktivieren es.",
    activeCountry: "Aktiv · Land {country}",
    provisioning: "Wird eingerichtet… (kann einige Minuten dauern)",
    release: "Freigeben",
    numberCountry: "Land der Nummer",
    searching: "Wird gesucht…",
    seeAvailable: "Verfügbare ansehen",
    perMonth: "{cost}/Mon.",
    getThis: "Diese Nummer nehmen",
    getOne: "Nummer holen",
    confirmRelease: "Möchten Sie die Nummer wirklich freigeben? Sie empfängt dann keine Anrufe mehr.",
    errNoneInCountry: "In diesem Land sind derzeit keine Nummern verfügbar.",
    errTelnyxInactive: "Die Telefonie ist für Ihr Konto noch nicht aktiv.",
    errSearchFailed: "Die Suche nach Nummern war nicht möglich.",
    errTelnyxInactiveContact: "Die Telefonie ist für Ihr Konto noch nicht aktiv. Melden Sie sich bei uns und wir schalten sie frei.",
    errNoNumbersNow: "Derzeit sind keine Nummern verfügbar.",
    errProvisionFailed: "Die Nummer konnte nicht geholt werden.",
    errReleaseFailed: "Die Nummer konnte nicht freigegeben werden.",
  },
  voiceLang: {
    title: "Stimme und Sprache",
    assistantVoice: "Stimme des Assistenten",
    recommended: "(empfohlen)",
    listenVoiceTitle: "Stimme {voice} anhören",
    loading: "Wird geladen…",
    stop: "Stopp",
    listen: "Anhören",
    mainLanguage: "Hauptsprache",
    extraLanguages: "Weitere Sprachen, die er sprechen kann",
    useIdentityTitle: "Identität des Chat-Agenten verwenden",
    useIdentityDesc: "Übernimmt Name, Persönlichkeit und Tonfall, die Sie in den allgemeinen Einstellungen festgelegt haben.",
    voiceAssistantName: "Name des Sprachassistenten",
    namePlaceholder: "z. B. Rezeption Málaga Centro Suites",
    greeting: "Begrüßung beim Abheben",
    optional: "(optional)",
    greetingPlaceholder: "Wenn leer, begrüßt der Assistent automatisch mit seiner Identität.",
    errPlayback: "Die Hörprobe konnte nicht abgespielt werden.",
    errGenerate: "Die Hörprobe konnte nicht erzeugt werden. Bitte versuchen Sie es erneut.",
  },
  languages: {
    es: "Spanisch",
    en: "Englisch",
    fr: "Französisch",
    pt: "Portugiesisch",
    it: "Italienisch",
    de: "Deutsch",
    ar: "Arabisch",
  },
  countries: {
    ES: "Spanien",
    US: "Vereinigte Staaten",
    GB: "Vereinigtes Königreich",
    FR: "Frankreich",
    IT: "Italien",
    DE: "Deutschland",
    PT: "Portugal",
    CO: "Kolumbien",
    MX: "Mexiko",
  },
  days: {
    mon: "Mo",
    tue: "Di",
    wed: "Mi",
    thu: "Do",
    fri: "Fr",
    sat: "Sa",
    sun: "So",
  },
  listings: {
    title: "Unterkünfte, für die er antwortet",
    desc: "Wählen Sie, für welche Unterkünfte der Sprachagent Anrufe entgegennimmt.",
    all: "Alle Unterkünfte",
    some: "Nur einige",
    scopeNoteBefore: "Er antwortet für",
    scopeNoteStrong: "alle",
    scopeNoteAfter: "Unterkünfte des Kontos, auch für die, die Sie künftig hinzufügen.",
    searchPlaceholder: "Unterkunft suchen…",
    selectAll: "Alle auswählen",
    clearAll: "Auswahl aufheben",
    loadingListings: "Unterkünfte werden geladen…",
    noListings: "Dieses Konto hat keine Unterkünfte.",
    noMatches: "Keine Treffer.",
    noneWarn: "Wenn Sie keine auswählen, antwortet der Agent für alle.",
    allDesc: "Einschließlich der, die Sie später hinzufügen.",
    someDesc: "Nur die, die Sie unten ankreuzen.",
    selectedShort: "{n} von {total}",
  },
  capabilities: {
    title: "Was er kann",
    knowledgeTitle: "Woher er seine Informationen bezieht",
    knowledgeDesc: "Wählen Sie, was der Assistent prüft, wenn jemand nach dem Inserat fragt.",
    messagesTitle: "Nachrichten aufnehmen",
    messagesDesc: "Wenn er etwas nicht weiß, nimmt er die Nachricht des Gastes auf und benachrichtigt Sie.",
    linksTitle: "Links nach dem Anruf senden",
    linksDesc: "Nach dem Auflegen sendet er bei Bedarf den nützlichen Link (Check-in oder Buchung) per WhatsApp.",
    photosTitle: "Fotos der Ausstattung und Annehmlichkeiten senden",
    photosDesc: "Fragt der Anrufer nach einer Ausstattung, zu der es Fotos gibt, schickt der Agent sie per WhatsApp an die Nummer, von der aus angerufen wird.",
  },
  doc: {
    title: "Dokument mit Informationen",
    desc: "Laden Sie eine PDF- oder Word-Datei hoch und der Agent kann mit deren Inhalt antworten.",
    dropTitle: "Dokument hochladen",
    dropHint: "PDF oder Word (.docx), bis 15 MB",
    uploading: "Dokument wird hochgeladen…",
    replace: "Ersetzen",
    remove: "Entfernen",
    chars: "{n} Zeichen gelesen",
    noText: "Dieses Dokument ist gescannt: Es besteht aus Bildern, daher kann der Text nicht gelesen werden. Laden Sie eines mit echtem Text hoch.",
    errType: "Die Datei muss eine PDF- oder Word-Datei (.docx) sein.",
    errSize: "Die Datei darf nicht größer als 15 MB sein.",
    errUpload: "Das Dokument konnte nicht hochgeladen werden. Bitte versuchen Sie es erneut.",
    errRemove: "Das Dokument konnte nicht entfernt werden. Bitte versuchen Sie es erneut.",
    fuenteBase: "Die Wissensdatenbank",
    fuenteBaseDesc: "Die Informationen Ihrer Inserate: Check-in, Ausstattung, Regeln und FAQ.",
    fuenteDoc: "Ein eigenes Dokument",
    fuenteDocDesc: "Nur die PDF- oder Word-Datei, die Sie unten hochladen, mit ihren Anweisungen.",
    fuenteAmbas: "Beides",
    fuenteAmbasDesc: "Zuerst das Dokument und, wenn die Antwort dort fehlt, die Informationen des Inserats.",
    verTexto: "Ansehen, was der Assistent liest",
    abrirOriginal: "Dokument öffnen",
    previewTitle: "Was der Assistent aus Ihrem Dokument liest",
    previewSub: "Dies ist der aus der Datei gelesene Text. Wenn hier etwas fehlt, weiß es der Assistent auch nicht.",
    previewVacio: "Aus dieser Datei konnte kein Text gelesen werden.",
    cerrar: "Schließen",
    noUsado: "Es ist hochgeladen, aber der Assistent nutzt es derzeit nicht: Sie haben gewählt, nur mit der Wissensdatenbank zu antworten.",
    faltaDoc: "Laden Sie ein Dokument hoch, um es als Quelle auswählen zu können.",
  },
  hours: {
    title: "Servicezeiten",
    specific: "Bestimmte Zeiten",
    closed: "Geschlossen",
    afterHours: "Außerhalb der Zeiten",
    afterVoicemail: "Sprachnachricht aufnehmen",
    afterMessage: "Hinweis abspielen und auflegen",
    afterMessagePlaceholder: "Hinweis, der außerhalb der Zeiten abgespielt wird.",
  },
  recording: {
    title: "Aufzeichnung und Compliance",
    recordTitle: "Anrufe aufzeichnen",
    recordDesc: "Speichert das Audio der Anrufe, damit Sie es nachhören können.",
    noticeTitle: "Aufzeichnung ansagen",
    noticeDesc: "Der Assistent weist zu Beginn darauf hin, dass der Anruf aufgezeichnet werden kann (nach DSGVO empfohlen).",
    transcribeTitle: "Anrufe transkribieren",
    transcribeDesc: "Erstellt einen Text zu jedem Gespräch.",
    transcribeNeedsRecord: "Transkripte entstehen aus dem Audio: Ist „Anrufe aufzeichnen“ aus, werden keine erzeugt.",
  },
  advanced: {
    title: "Erweitert",
    maxDuration: "Maximale Anrufdauer",
    minutesOption: "{n} Minuten",
    aiEngine: "KI-Engine",
  },
  save: {
    saved: "Gespeichert ✓",
    save: "Änderungen speichern",
    dirty: "Sie haben nicht gespeicherte Änderungen",
    clean: "Alles gespeichert",
  },
  credits: {
    title: "Anrufminuten",
    desc: "Jeden Monat enthaltene Minuten je nach Ihren Unterkünften. Wenn sie aufgebraucht sind, können Sie jederzeit aufladen.",
    loading: "Guthaben wird geladen…",
    minutesLeft: "Min. verfügbar",
    recharge: "Aufladen",
    includedThisMonth: "{used} von {total} enthaltenen Min. in diesem Monat genutzt",
    purchased: "{min} Min. gekauft",
    empty: "Ihre Minuten sind aufgebraucht. Laden Sie auf, um weiterhin Anrufe zu empfangen.",
    error: "Das Guthaben konnte nicht geladen werden.",
    modal: {
      title: "Minuten aufladen",
      sub: "Wählen Sie ein Paket. Es ist eine einmalige Zahlung und die Minuten werden sofort Ihrem Guthaben gutgeschrieben.",
      pay: "Mit Karte zahlen",
      secure: "Sichere Zahlung mit Stripe.",
      close: "Schließen",
      error: "Die Zahlung konnte nicht gestartet werden. Bitte versuchen Sie es erneut.",
    },
  },
};
